import React from "react";
import { getPatientById,getProductRequirements,getProductRDetails, getPentityByKey
,getScheduleByPatient,rotateFile,getMenus,getStatus,getUsersWoP,deleteNotes,shareFile, addNotes,deleteFile,getNotes,getRoles,convert,s3UploadWithOptions, getSchedules,getTemplates,getAccounts, signedUrl,s3Upload,addFile,getFile,updateMaster,getFileAnnotation
 } from "../../crud/auth.crud";
 import { Link } from "react-router-dom";
 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ReactS3Uploader from "react-s3-uploader"
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { Figure } from "react-bootstrap";
import S3Image from "../../widgets/S3Image";
import CalendarEventsByPentity from "../../widgets/CalendarEventsByPentity";
import listPlugin from '@fullcalendar/list';
import { RectangleSelector} from 'react-image-annotation/lib/selectors'
import Annotation from 'react-image-annotation'
import {MenuItem} from "@material-ui/core";
import {  format } from 'date-fns'
import Draggable from 'react-draggable';
import FFMPEG from "react-ffmpeg";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import DeleteIcon from '@material-ui/icons/Delete';

import AddTemplateData from './AddTemplateData';

import ViewTemplateData from './ViewTemplateData';

import FileUploadPreview from './FileUploadPreview';


import CircularProgress from '@material-ui/core/CircularProgress';

import axios from "axios";

import { ReactMediaRecorder } from "react-media-recorder";

import Paper from '@material-ui/core/Paper';

import CalendarToday from '@material-ui/icons/CalendarToday';

import Share from '@material-ui/icons/Share';

import AudiotrackIcon from '@material-ui/icons/Audiotrack';

import VideocamOffRoundedIcon from '@material-ui/icons/VideocamOffRounded';

import MusicVideoIcon from '@material-ui/icons/MusicVideo';

import StopIcon from '@material-ui/icons/Stop';
import Drawer from '@material-ui/core/Drawer';


import ListAlt from '@material-ui/icons/ListAlt';
import { Tooltip,IconButton } from "@material-ui/core";  
import ReactAudioPlayer from 'react-audio-player';

import {Recorder} from 'react-voice-recorder'
import './voice.css'

import Chat from './Chat';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ErrorOutlineRounded } from "@material-ui/icons";
import ProductRequirement from "../../widgets/ProductRequirement";

                  
export default class ViewPatient extends React.Component
{

	
	state = {
		audioDetails : {
url: null,
blob: null,
chunks: null,
duration: {
h: null,
m: null,
s: null,
}
},
    	patients:[],
    	templates:[],
    	menu: false,
    	open:false,
    	annotations: [],
    annotation: {},
    type:'RECTANGLE',
    fileKey:'',
    status:false,
    downloadUrl:'',
    fileType:'',
    id:'',
    input:'',
    mStatus:[],
    permission:[],
    fromPath:'',
    postObj:{},
    page:1,
    todoView:'calendar',
    Referral:'',
    Practice:'',
    mediaBlobUrl:null,
    videoOpen:false,
	videoRecord:false,
	videoDetails:false,
	uploadComplete:false,
	users:[],
	shareOpen:false,
	fileKey:'',
	userKey:'',
	shareStatus:false,
	mediaapisupport:false,
	productRequirements:null,
	drawerViewOpen:false,
	selectedDrawerItem:{},
	statusMap:{},
	
  	}
	
	
constructor(props)
{
	let mediaapisupport = false;
	navigator.mediaDevices.getUserMedia({audio:true,video:true})
	.then(function(stream) {
		/* use the stream */
		console.log("issupportedmedia",stream);
		mediaapisupport = true;
	})
	.catch(function(err) {
		/* handle the error */
		console.log("not",err);
		mediaapisupport = false;
	});
	if(isMobile === true)
	{
		console.log("accessed from mobile")
		mediaapisupport = false;
	}
	else
	{
		mediaapisupport = true;
	}
  
super(props);
  this.state = {
  	audioDetails : {
url: null,
blob: null,
chunks: null,
duration: {
h: null,
m: null,
s: null,
}
},
      menu: false,
      patients:[],
      templates:[],
      mAccounts:[],
      //patient:this.props.location.data,
      fromPath:'',
      imageUrl:'media/misc/loading.gif',
      imageOpen:false,
      annotations: [],
	    annotation: {},
	    type:'RECTANGLE',
	    fileKey:'',
	    status:false,
	    downloadUrl:'',
	    fileType:'',
	    id:'',
	    input:'',
	    statusFlag:false,
    statusMessage:'',
     statusColor:'alert-success',
     mStatus:[],
     permission:[],
     postObj:{},
     page:1,
     todoView:'calendar',
     Referral:'',
    Practice:'',
    mediaBlobUrl:null,
    videoOpen:false,
	videoRecord:false,
	videoDetails:false,
	uploadComplete:false,
	users:[],
	shareOpen:false,
	fileKey:'',
	userKey:'',
	shareStatus:false,
	mediaapisupport:mediaapisupport,
	productRequirements:null,
	drawerViewOpen:false,
	selectedDrawerItem:{},
	statusMap:{},

    };
  
  console.log("patient id"+this.props.location.data);
  this.toggleMenu = this.toggleMenu.bind(this);
  
}

 


onChange = (annotation) => {
    this.setState({ annotation })
  }

  onSubmit = (annotation) => {
    const { geometry, data } = annotation

    this.setState({
      annotation: {},
      annotations: this.state.annotations.concat({
        geometry,
        data: {
          ...data,
          id: Math.random()
        }
      })
    })
  }
onInput(e) {
    this.setState({
      input: e.target.value
    })
  }

  onSelectTag=(e,value)=> {
	console.log("eeeee",e);
	let tguser=[];
	  if(value !== null && value !== undefined)
	  {
		console.log("value",value);
		
		this.setState({userKey:value.userId});
	  }
	}

	share = () =>
	{
		if(this.state.userKey!=='' && this.state.fileKey!=='')
		{
			shareFile(this.state.patient.pEntityId,this.state.fileKey,this.state.userKey)
	        .then(resp => {
	            //console.log(resp);
				this.setState({shareStatus:true})
	        })
		}


	}

	toggleViewDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({drawerViewOpen:false})
  };

  	  addTemplate=(template,pentity)=>
  {
    this.setState({addtemTemplate:template,
      addtemPatient:pentity,addTemplateOpen:true});
  }
  viewTemplate=(template,pentity)=>
  {
    this.setState({viewtemTemplate:template,
      viewtemPatient:pentity,viewTemplateOpen:true});
  }



  sendMessage=()=>
  {
  	if(this.state.input!=='')
  	{
	  	let notesObj = {
	  		notes: this.state.input
	  	}
		addNotes(this.state.patient.pEntityId,notesObj,'pentity')
	                      .then(resp => {
	                        //props.register(accessToken);
	                       
	                        console.log(resp);
	                        getNotes(this.state.patient.id).then((response) => {
					      	console.log("notes:::",response);
					  		this.setState({notes:response.data,input:''})
					      });
	                       
                      })
    }
  }


saveAnnotation = () =>
{

	 let data  = {
                      'annotations' : {'annotate':this.state.annotations}
                   
                    };

	updateMaster('files',this.state.fileKey,data)
                      .then(resp => {
                        //props.register(accessToken);
                       
                        this.setState({annotations:[],annotation:{},fileKey:'',status:true})
                       
                      })
}
handleClose = () =>
  {
    this.setState({open:false});
  }

  imageClose = () =>
  {
    this.setState({imageOpen:false,audioKey:null, audioUrl:null});
  }

  audioClose = () =>
  {
    this.setState({audioOpen:false});
  }

  videoClose = () =>
  {
    this.setState({videoOpen:false});
  }

  shareClose = () =>
  {
    this.setState({shareOpen:false});
  }

  viewTemplateClose = () =>
  {
    
      this.setState({ viewTemplateOpen:false});
   
    
  }

  addTemplateClose = () =>
  {
    getPentityByKey(this.state.patient.pEntityId).then(response => response.data)
      .then((data) => {
        let patients = [];
        patients.push(data);
        this.setState({ addTemplateOpen:false,pentity:data,patient:data,patients:patients,patientLoading:false,patientSelected:true});
                                 
                         
    })

	this.setState({ addTemplateOpen:false});
    
  }


  vRecordClose = () =>
  {
	  this.setState({videoRecord:false});
  }
handleOpen = () =>
  {
    this.setState({open:true});
  }

 fileCategory=(files,category) =>
 {

 	let ret = [];
 	console.log(category,this.state[category]);
 	files.map((x)=>{
 		console.log(x.createdByRoleKey)
 		if(this.state[category].includes(x.createdByRoleKey))
 		{
 			ret.push(x);
 		}
 	}

 	)

 	return ret;
 }

getSignedUrl = (file, callback) =>
  {
    //this.setState({open:true});
    console.log("getSignedUrl");
    const params = {
    objectName: file.name,
    contentType: file.type
  };
    console.log(params);
	  signedUrl({ params })
	  .then(data => {
	    //callback(data.data);
	    //console.log(data.data);
	   // s3Upload(data.data.signedUrl,file,{headers:{'x-amz-acl': 'public-read','Content-Type' : params.contentType}})
	    s3Upload(data.data.signedUrl,file)
	    .then(response => response.data)
		    .then((data) => {
		     
		      	console.log(data);
		     });
	  })
	  .catch(error => {
	    //console.log(error);
	  });

}

 getUploadParams = async  ({ file, meta: { name } }) => {

 	console.log(this.state.patient.id);
 	let id = this.state.patient.id;
 	let url ="";
     await signedUrl({ name,id })
	  .then(data => {
  	 	url = data.data.signedUrl;
  	 	
  	})
	  console.log("url 2===="+name + "---id:"+id);
	  //console.log("url===="+ url);
	  //console.log(file);
	  return { body: file, meta: {}, url:  url,method:'PUT'}
	}

   handleSubmit = (files, allFiles) => {
    //console.log(files.map(f => f.meta))
    //allFiles.forEach(f => f.remove())
    //console.log('here');
    //files.map((f) => (
    		//console.log(f.meta)
    	//))
  }

  imageView = async (id,previewFileKey,fileKey,originalFileKey,fileType) => {
  	console.log("filekey",fileKey);

  	var url='';

  	if(fileType.includes("image"))
	{
		await getFileAnnotation(fileKey).then(response => response.data)
		      .then((data) => {
		      	if(data!=null && data[0]!=null && data[0].annotations!=null)
		      	{
		      	this.setState({annotations: data[0].annotations.annotate})
		      }
		      });

		url=previewFileKey;

	}
	else
	{
		url=originalFileKey;
	}
	console.log("fileType::::",fileType);

	let mediaapisupport = false;
	//await navigator.mediaDevices.getUserMedia({audio:true,video:true})
	//.then(function(stream) {
	//	/* use the stream */
	//	console.log("issupportedmedia",stream);
	//	mediaapisupport = true;
	//})
	//.catch(function(err) {
	//	/* handle the error */
	//	console.log("not",err);
	//	mediaapisupport = false;
	//});
	//
	if(isMobile === true)
	{
		console.log("accessed from mobile")
		mediaapisupport = false;
	}
	else
	{
		mediaapisupport = true;
	}
  	this.setState({imageUrl:'media/misc/loading.gif',imageOpen:true,id:fileKey,originalFileKey:url,fileType:fileType,mediaapisupport:mediaapisupport});
  	await getFile(id,url).then(response => response.data)
	      .then((data) => {
	      	this.setState({imageUrl: data.downloadUrl,fileKey:fileKey,status:false,fileType:fileType})
	      });
	

	
  }

  audioView = (id,previewFileKey,fileKey,originalFileKey,fileType) => {
  	console.log("filekey",fileKey);

  
  	getFile(id,originalFileKey).then(response => response.data)
	      .then((data) => {
	      	this.setState({audioUrl: data.downloadUrl,audioKey:fileKey})
	      });
	

	
  }
  videoView = (id,previewFileKey,fileKey,originalFileKey,fileType) => {
	console.log("filekey",fileKey);


	getFile(id,originalFileKey).then(response => response.data)
		.then((data) => {
			this.setState({mediaBlobUrl: data.downloadUrl,videoOpen:true})
		});
  

  
}

 //read querystring 
 getQueryVariable=(variable)=>
 {
	   var query = window.location.search.substring(1);
	   //console.log(query)//"app=article&act=news_content&aid=160990"
	   var vars = query.split("&");
	   //console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
	   for (var i=0;i<vars.length;i++) {
				   var pair = vars[i].split("=");
				   //console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
	   if(pair[0] == variable){return pair[1];}
		}
		return(false);
 }

  updateStatus(pentity)
  {
  		console.log(pentity);
  		let data ={'status':this.state.tStatus};
  		updateMaster('pentity',pentity.pEntityId,data)
  		.then((response) => {
  			console.log("update status::::",response);
  			if(response.data !='Success')
  			{
  			 this.setState({open:false,statusFlag:true,statusMessage:response.data,statusColor:'alert-danger'});
  			}
  			else
  			{
  			 this.setState({open:false,statusFlag:false,statusFlag:true,statusMessage:'Status updated successfully',statusColor:'alert-success'});
  			 //this.setState({pRights: this.state.pRights.map(el => (el.id === pentity.id ? {...el, status :this.state.tStatus}: el))});	
  		
  			}
  			 window.scrollTo(0,0);

  		})
  }

delete=()=>
{
	//console.log("id",this.state.id);
	deleteFile(this.state.id).then(response => response.data)
    .then((data) => {
      
      getPatientById(this.state.patient.id).then(response => response.data)
	    .then((data) => {
	      this.setState({ patients: data ,imageOpen:false,id:''})
	     // console.log(data);
	     });
     });
}



rotate=()=>
{
	console.log("id",this.state.id);
	rotateFile(this.state.id).then(response => response.data)
    .then((data) => {
      this.setState({imageUrl:'media/misc/loading.gif',imageOpen:true,id:this.state.fileKey});
		setTimeout(() => {
  			console.log('Hello, World!')
  			getFile(this.state.id,this.state.originalFileKey).then(response => response.data)
		      .then((data) => {
		      	console.log('Hello, World!1')
		     	this.setState({imageUrl: data.downloadUrl,fileKey:this.state.fileKey,status:false})
		     });
		}, 5000);

      
      
     });
}

handleAudioStop(data)
{
	console.log(data)
	this.setState({ audioDetails: data });
}
async handleAudioUpload(file) {
	console.log(file);
	if(file!=null && file.type!=null )
	{
		console.log(this.state.patient.id);
	 	let id = this.state.patient.id;
	 	let url ="";
	 	let name = format(new Date(),"MM-dd-yyyy-HH-mm") + ".mp3"
	     await signedUrl({ name,id })
		  .then(data => {
	  	 	url = data.data.signedUrl;
	  	 	var options = {
	        headers: {
	          'Content-Type': file.type
	        }
	      };

	      s3UploadWithOptions(url, file, options)
	      .then((resp) =>
	      {
	      	addFile(id,name,file.size,file.type,this.state.id).then(response => response.data)
		      .then((data) => {
		      		getPatientById(id).then(response => response.data)
				    .then((data) => {
				    	const reset = {
							url: null,
							blob: null,
							chunks: null,
							duration: {
								h: null,
								m: null,
								s: null,
							}
						}

				      this.setState({ patients: data,audioDetails: reset })
				      //console.log(data);
				     });
		      });
	      })
	  	 	
	  	})
	}
	  
}
async uploadVideo(mediaBlobUrl) {
	console.log(mediaBlobUrl);
	let file = mediaBlobUrl;
	if(mediaBlobUrl!=null )
	{
		this.setState({videoDetails:true});
		const config = { responseType: 'blob' };
		axios.get(mediaBlobUrl, config).then(async response => {

			let name = "SC-"+format(new Date(),"MM-dd-yyyy-HH-mm") + ".mp4"
			let file = new File([response.data], name,{ type: 'video/mp4' });      

			let id = this.state.patient.id;
	  
				convert(file,id,name)
				.then((resp) =>
				{
					if(resp.data === "success")
					{
						addFile(id,name,file.size,file.type,this.state.id).then(response => response.data)
						.then((data) => {
								getPatientById(id).then(response => response.data)
							.then((data) => {
								const reset = {
									url: null,
									blob: null,
									chunks: null,
									duration: {
										h: null,
										m: null,
										s: null,
									}
								}
		
								this.setState({ patients: data,videoDetails:false,uploadComplete:true})
								//console.log(data);
							});
						});
					}
				});
	
			
			
		});


		
	}
	  
}
handleRest()
{
	const reset = {
		url: null,
		blob: null,
		chunks: null,
		duration: {
			h: null,
			m: null,
			s: null,
		}
	}
this.setState({ audioDetails: reset });
}

PaperComponent(props) {
  return (
    <Draggable handle="#audio-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

loadImage=()=>{
	getFile(this.state.id,this.state.originalFileKey).then(response => response.data)
	      .then((data) => {
	      	this.setState({imageUrl: data.downloadUrl,fileKey:this.state.fileKey,status:false})
	      });
}

 handleChangeStatus = ({ meta }, status) => {
    //console.log(status, meta)
	const fileId = meta.id;

    let id = this.state.patient.id;
    if(status=="done")
    {

    	addFile(id,meta.name,meta.size,meta.type).then(response => response.data)
	      .then((data) => {
	      		getPatientById(id).then(response => response.data)
			    .then((data) => {
			      this.setState({ patients: data });

				  this.setState({
					statusMap: {
						...this.state.statusMap,
						[fileId]: "verified"
					}
					});
			      //console.log(data);
			     });
	      });
    }
  }

 toggleMenu(){
 	//console.log("toggleMenu");
    this.setState({ menu: !this.state.menu })
  }

  handleDeleteNotes(notesKey){
	if (window.confirm("Are you sure you want to delete this note?")) 
    {
		console.log("noteskey::",notesKey);
		deleteNotes(notesKey) 
		.then((data) => {
			let notes = this.state.notes;
			let index =  notes.findIndex(x=>x.id === notesKey);
			notes.splice(index,1);
			this.setState({notes});
			//console.log(data);

		});
	}
  }
  
componentDidMount()
  {
  	

	//side menu collapse
	 if ( !document.body.classList.contains("kt-aside--minimize"))
	 {
			  //removeCSSClass(document.body, "kt-aside--minimize");
			  document.body.classList.add("kt-aside--minimize");
	}

	
	console.log("[rp[d",this.props.location);
    let patientId = this.getQueryVariable("id");
	let patientKey = this.getQueryVariable("key");

	if(this.props.location.data!==undefined && this.props.location.data!==null)
	{
		patientId = this.props.location.data.id;
		patientKey = this.props.location.data.pEntityId;
	}

  	let tempSchedules=[];
    if(patientId !== null && patientKey!==null)
    {

    	getRoles().then(response => response.data)
    .then((data) => {
    	let referralRole='';
    	let practiceRole='';
    	data.filter(x=> x.tag==='Referral').map((role)=>
    	{
    		referralRole = referralRole + "," + role.roleId;
    	});

    	data.filter(x=> x.tag===null).map((role)=>
    	{
    		practiceRole = practiceRole + "," + role.roleId;
    	});
    	console.log("roles class:::::",practiceRole,referralRole);
      this.setState({ Referral:referralRole,Practice:practiceRole })
      //console.log(this.state.users)
     })



	    getPatientById(patientId).then(response => response.data)
	    .then((data) => {
	      this.setState({ patients: data,tStatus:data[0].status,patient:data[0]})
	      //console.log(data[0]);
		  document.title = data[0].firstName + ' ' + data[0].lastName;
	     });

	    	 getStatus().then(response => response.data)
      .then((data) => {
        this.setState({ mStatus: data })
       // console.log(data);
       });

      getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   this.setState({ permission: perms })

                }
     });

	    getTemplates().then(response => response.data)
	    .then((data) => {
	      this.setState({ templates: data })
	      //console.log(data);
	     });
	     getAccounts().then(response => response.data)
      .then((data) => {
        this.setState({ mAccounts: data })
       // console.log(data);
       });
      /////notes
      getNotes(patientId).then((response) => {
      	console.log("notes:::",response);
  		this.setState({notes:response.data})
      });

	  getUsersWoP().then(response => response.data)
	  .then((data) => {
		this.setState({ users: data })
		//console.log(this.state.users)
	   })

	  getProductRequirements(patientKey).then(response => response.data)
	  .then((data) => {
		this.setState({ productRequirements: data })
		//console.log(this.state.users)
	   });


//console.log(this.props.location.data);
      let postObj = {pEntityKey:patientKey};

      let referredTo ='';
	  let referredToAccountKey='';
	  let referredToAccount='';
      console.log("tasks postobj::::",postObj);
      getSchedules(1,postObj)//.then(response => response.data)
    .then((response) => {
    	
	      console.log("task details :::::",response.data);
	      response.data.map((x)=>(
	      	console.log("referred name::::",x.referredToUserName,x.createdOn),
	      	referredTo = x.referredToUserName,
			referredToAccountKey = x.assignedToAccountKey
	      ));
		  console.log("referredToAccountKey:::",referredToAccountKey)
		 
		  console.log("referredToAccount:::",referredToAccount)
	      this.setState({referredTo:referredTo,referredToAccountKey:referredToAccountKey});
     })

    let fromPath ='';
	if(this.props.location.fromPath!=null) this.setState({fromPath: this.props.location.fromPath});
	if(this.props.location.postObj!=null) this.setState({postObj: this.props.location.postObj});
	if(this.props.location.page!=null) this.setState({page: this.props.location.page});
    
  }
}

render()
{

	const show = (this.state.menu) ? "show" : "" ;
    return (
    	<>

    			{this.state.statusFlag && (
    				<div className="row">
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                     </div>
                      )}
    						{/*patient calendar and patient information*/}
							<div className="row">
								
								<div className="col-lg-8">
									<div className="row">
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													<h3 className="kt-portlet__head-title">
														To Do's
													</h3>
												</div>
												<div className="kt-portlet__head-toolbar">
													
													<div className="kt-portlet__head-group">
														{/*<div className="btn-group">
															<button type="button" className="btn btn-elevate btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																<i className="la la-plus"></i> Add Event
															</button>
															<div className="dropdown-menu dropdown-menu-right">
																<a className="dropdown-item" href="#">Action</a>
																<a className="dropdown-item" href="#">Another action</a>
																<a className="dropdown-item" href="#">Something else here</a>
																<div className="dropdown-divider"></div>
																<a className="dropdown-item" href="#">Separated link</a>
															</div>
														</div>*/}
														{this.state.todoView ==='calendar' &&
														<Tooltip
	          										title="Switch to List view" 

	          									><ListAlt style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.setState({todoView:'list'})} /></Tooltip>
														}
														{this.state.todoView ==='list' &&
														<Tooltip
	          										title="Switch to Calendar view" 

	          									><CalendarToday style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.setState({todoView:'calendar'})}/></Tooltip>
														}
													</div>
													 <Tooltip
															  title= {this.state.showtodo?"Hide":"Show"}
															  >
																<Button
																variant="outlined"
																color="primary"
																	onClick={() => this.setState({showtodo:!this.state.showtodo})}
																	
																  >
																	{this.state.showtodo?"Hide":"Show"}
																  </Button>
																  </Tooltip>
												</div>
											</div>
											{this.state.showtodo &&
											<div className="kt-portlet__body">

												{this.state.todoView ==='calendar' && this.state.patients.map((patient)=>(

												<CalendarEventsByPentity type={this.state.todoView} pEntityId={patient.pEntityId} name={patient.firstName+' '+patient.lastName}/>
												))}

												{this.state.todoView ==='list' && this.state.patients.map((patient)=>(

												<CalendarEventsByPentity type={this.state.todoView} pEntityId={patient.pEntityId} name={patient.firstName+' '+patient.lastName}/>
												))}
											</div>
											}
										</div>
										</div>
									</div>
									<div className="row">
										{this.state.patients.map((patient) => (
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													
													<h3 className="kt-portlet__head-title">
														Referral Template
													</h3>
												</div>
												<div className="kt-portlet__head-toolbar">
													
													<div className="kt-portlet__head-group">
														<div className="btn-group">
															<button type="button" className="btn btn-elevate btn-danger dropdown-toggle" onClick={ this.toggleMenu } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																<i className="la la-plus"></i> Template Options
															</button>
															<div className={"dropdown-menu dropdown-menu-right "+ show}>
																{this.state.templates !== null && this.state.templates.map((template)=>(
																	<>
																  <a className="dropdown-item" href="#" onClick={()=>this.addTemplate(template,patient)}>
                                      
                                      									{template.templateName}</a>
                                        							
																	</>
																))}
																
															</div>
														</div>
													</div> &nbsp;
													 <Tooltip
															  title= {this.state.showtemplate?"Hide":"Show"}
															  >
																<Button
																variant="outlined"
																color="primary"
																	onClick={() => this.setState({showtemplate:!this.state.showtemplate})}
																	
																  >
																	{this.state.showtemplate?"Hide":"Show"}
																  </Button>
																  </Tooltip>
												</div>
											</div>
											{this.state.showtemplate &&
											<div className="kt-portlet__body">
												<div className="row">
													<div className="col">
														{patient.templates !=null && patient.templates.filter(x=> x.roleTag===null).length>0 &&
														<div className="kt-section">
															<h3>Practice</h3>
															<div className="kt-section__content">
																<div className="row">
																
																{patient.templates.filter(x=> x.roleTag===null).map((template)=>(
																	<div className="col-lg-12">
																	
																	<p>
                              <a href="#" onClick={()=>this.viewTemplate(template,patient)}> {template.templateName}</a>
                                <br/>{template.createdByUserName!=null && template.createdByUserName + ", "+ format(new Date(template.createdDate),"MM/dd/yyyy hh:mm")}
                              </p>
																	</div>
																))}
														
																</div>
															</div>
														</div>
														}
													</div>
													<div className="col">
														{patient.templates !=null && patient.templates.filter(x=> x.roleTag==='Referral').length>0 &&
														<div className="kt-section">
															<h3>Referral</h3>
															<div className="kt-section__content">
																<div className="row">
																
																{patient.templates.filter(x=> x.roleTag==='Referral').map((template)=>(
																	<div className="col-lg-12">
																	<p>
                              <a href="#" onClick={()=>this.viewTemplate(template,patient)}> {template.templateName}</a>
                                <br/>{template.createdByUserName!=null && template.createdByUserName + ", "+ format(new Date(template.createdDate),"MM/dd/yyyy hh:mm")}
                              </p>
																	</div>

																	
																))}
														
																</div>
															</div>
														</div>
														}
													</div>
												</div>
											</div>
											}
										</div>
										</div>
										))}
									</div>
									{this.state.productRequirements!==null  && (
									<div className="row">
									
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													<h3 className="kt-portlet__head-title">
														Staged Inventory
													</h3>
												</div>
												
											</div>
											<div className="kt-portlet__body">
												<div className="row">
													<div className="col">
														
															<div className="kt-section__content">
																<div className="row">
																
																{this.state.productRequirements!==null && this.state.productRequirements.map((pd)=>(
																	<div className="col-lg-12">
																		<p>
																		<a href="#" onClick={()=>this.setState({selectedDrawerItem:pd,drawerViewOpen:true})}>{pd.implantName}</a> <br/>
																		{pd.requirementPostedUser!=="" && pd.requirementPostedUser!=="" && pd.requirementPostedUser + ", "+ format(new Date(pd.createdOn),"MM/dd/yyyy hh:mm")}
																		</p>
																	</div>
																))																	
																}
														
																</div>
															</div>
														
													</div>
													
												</div>
											</div>
										</div>
										</div>
										
									</div>)}
									<div className="row">
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													<h3 className="kt-portlet__head-title">
														Patient Notes
													</h3>
												</div>
											</div>
											<div className="kt-chat">
												<div className="kt-portlet__body">
													<div className="kt-scroll kt-scroll--pull" style={{'min-height':'200px','max-height':'350px','overflow':'auto'}} data-mobile-height="300">
														{this.state.notes!=null && this.state.notes.map((notes)=>(
														<div className="kt-chat__messages">
															<div className="kt-chat__message">
																<div className="kt-chat__user">
																	{/*<span className="kt-media kt-media--circle kt-media--sm">
																		<img src="media/users/default.jpg" alt="image"/>
														</span>*/}
																	{/*<a href="#" className="kt-chat__username">{notes.createdByFirstName + ' ' + notes.createdByLastName}</a>*/}
																	<span className="kt-chat__datetime">
																    {this.state.permission.includes("NOTES:DELETE") &&
																	<Tooltip
																		title= "Delete Notes"
																		>
																		<DeleteIcon style={{ color: '#5578eb',fontSize: 20}} onClick={(e) => this.handleDeleteNotes(notes.id)}/>   
																		
																		</Tooltip>
																	}
																		{notes.createdByFirstName + ' ' + notes.createdByLastName + ' '}{format(new Date(notes.createdOn), 'MM/dd/yyyy hh:mm')}
																	
																	</span>
																	
																</div>
																<div className="kt-chat__text kt-bg-light-success" style={{fontSize:'12px'}}>
																
																	{notes.notes}
																	
																</div>
															</div>
														</div>
														))}
													</div>
													
												</div>
												<div className="kt-portlet__foot">
													<div className="kt-chat__input">
														<div className="kt-chat__editor">
														   
															<textarea
									                          margin="normal"
									                          placeholder="Notes"
									                          name="message"
									                          rows={5}
												              onChange={(e)=>this.setState({input:e.target.value})}
												              value={this.state.input}
												              style={{borderStyle:'solid', backgroundColor:'grey', borderColor: 'black', border: '1px solid black'}}
									                        />
														</div>
														<div className="kt-chat__toolbar">
															<div className="kt_chat__actions">
																<button type="button" onClick={this.sendMessage} className="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply">Add Notes</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										</div>
										{this.state.patients.map((patient) => (
										<div className="col">
											<Chat pentity={patient}/>
										</div>
										))}
									</div>

									
									<div className="row">
										
									</div>
									

								</div>
								{this.state.patients.map((patient) => (
								
								<div className="col-lg-4">
									<div className="row">
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
														Patient Details
													</h3>
												</div>
												<div className="kt-portlet__head-toolbar">
													 <Tooltip
															  title= {this.state.showPatient?"Hide":"Show"}
															  >
																<Button
																variant="outlined"
																color="primary"
																	onClick={() => this.setState({showPatient:!this.state.showPatient})}
																	
																  >
																	{this.state.showPatient?"Hide":"Show"}
																  </Button>
																  </Tooltip>
													</div>
											</div>
											{this.state.showPatient &&
											<div className="kt-portlet__body">
												<div className="kt-section">
													<div className="kt-section__desc">
														
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																Name :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{patient.firstName} {patient.lastName}
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																PID :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{patient.patientId}
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																DOB :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{format(new Date(patient.dateOfBirth), 'MM/dd/yyyy')}
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																Mobile :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{patient.mobile}
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																Referred By :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{
																		this.state.mAccounts!=null &&  patient.referredAccountKey!==null &&
																		(
																		this.state.mAccounts.filter(acc=> acc.accountId==patient.referredAccountKey).map((facc)=>(
																			facc.accountName
																		))
																		)
																		
																	}
																	{
																		this.state.mAccounts!=null &&  patient.referredAccountKey===null &&
																		(
																		this.state.mAccounts.filter(acc=> acc.accountId==patient.accountKey).map((facc)=>(
																			facc.accountName
																		))
																		)
																		
																	}
																</div>
															</div>

														</div>
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																Referred To :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{this.state.referredTo!==null? this.state.referredTo : ' '}
																	{this.state.referredToAccountKey!==undefined && this.state.referredToAccountKey!==null && this.state.mAccounts.filter(acc=> acc.accountId==this.state.referredToAccountKey).map((facc)=>(
																			' ('+facc.accountName+')'
																		))}
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																Batch Number :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{patient.batchNumber}
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col"  style={{fontSize:'12px'}}>
																Lot Number :
															</div>
															<div className="col">
																<div className="kt-section__title" style={{fontSize:'12px'}}>
																	{patient.lotNumber}
																</div>
															</div>
														</div>
													</div>
													
													
												</div>
											</div>
											}
										</div>
										</div>
									</div>
									
									<div className="row">
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
														Documents/Images
													</h3>
												</div>
												<div className="kt-portlet__head-toolbar">
													<div className="kt-portlet__head-group">
														<div className="btn-group">
															 <Tooltip
															  title= {"Add Docuemnts / Images"}
															  >
															<button type="button" className="btn btn-elevate btn-danger" onClick={ this.handleOpen } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																<i className="la la-plus"></i> Add Files
															</button>
															</Tooltip>
														</div>
													</div>
												</div>
											</div>
											<div className="kt-portlet__body">
												{patient.files !=null && patient.files.filter(x=> x.roleTag===null && x.parentFileId===null).length>0 &&
												<div className="kt-section">
													<h3>Practice</h3>
													<div className="kt-section__content">
														
														<div className="kt-widget4">
														
														{patient.files !=null && patient.files.filter(x=> x.roleTag===null && x.parentFileId===null).map((file)=>(
															 <div className="kt-widget4__item">
																<div className="kt-widget4__pic kt-widget4__pic--pic">
																	{file.fileType.includes("image") &&
																			<S3Image id={patient.id} originalFileKey={file.thumbFileKey}/>
																		}
																		{!file.fileType.includes("image") &&
																			<img src="media/icons/svg/Files/File.svg" style={{width:'20px',height:'20px'}}/>
																		}
																</div>
																 <div className="kt-widget4__info">
																		<a
                  															className="kt-widget4__username"
																		href="#"
																		/>
																		<Tooltip title={file.fileName}>
																	<a href="#" className="kt-widget4__title" onClick={()=>this.imageView(patient.id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																		
																		{patient.files.filter(x=> x.parentFileId===file.fileKey).length>0 && <AudiotrackIcon style={{ color: '#5867dd',fontSize: 12}}/>}
																		{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																		
																		
																	</a>
																	</Tooltip>
																	<p className="kt-widget4__text" style={{fontSize:'12px'}}>
																		{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																		</p>
																

															</div>
															</div>
														))}
														</div>
														
													</div>
												</div>
												}
												{patient.files!=null && patient.files.filter(x=> x.roleTag==='Referral' && x.parentFileId===null).length>0 &&
												<div className="kt-section">
													<h3>Referral</h3>
													<div className="kt-section__content">
														
														<div className="row">
														
														{patient.files!=null && patient.files.filter(x=> x.roleTag==='Referral' && x.parentFileId===null).map((file)=>(
															<div className="col-lg-12">
																<Tooltip title={file.fileName}>
																	<a href="#" onClick={()=>this.imageView(patient.id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																		{file.fileType.includes("image") &&
																			<S3Image id={patient.id} originalFileKey={file.thumbFileKey}/>
																		}
																		{!file.fileType.includes("image") &&
																			<img src="media/icons/svg/Files/File.svg"/>
																		}
																		{patient.files.filter(x=> x.parentFileId===file.fileKey).length>0 && <AudiotrackIcon style={{ color: '#5867dd',fontSize: 12}} />}
																		{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																		<br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																	</a>
																</Tooltip>

															</div>
														))}
														</div>
														
													</div>
												</div>
												}
											</div>
										</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
										<div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
														Record Voice Notes
													</h3>
												</div>
											</div>
											<div className="kt-portlet__body">
											<Recorder
												record={true}
												
												audioURL={this.state.audioDetails.url}
												showUIAudio
												handleAudioStop={data => this.handleAudioStop(data)}
												handleOnChange={(value) => this.handleOnChange(value, 'firstname')}
												handleAudioUpload={data => this.handleAudioUpload(data)}
												handleReset={() => this.handleRest()} />
											</div>
										</div>
										</div>
									</div>
									
								</div>
								))}
							</div>
							
							
							{/*<div className="row">
	        					<div className="col-lg-12">
                        			<Link to={{pathname:this.state.fromPath,data: this.state.postObj,page:this.state.page}}>Back</Link>
	        					</div>
	        				</div>
												*/}
						
							<Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
 
						        <DialogTitle id="form-dialog-title">Drag & Drop documents/images to upload</DialogTitle>
						        <DialogContent>
						          {/*<DialogContentText>
						            Enter your notes for this schedule
						          </DialogContentText>*/}
						          <Dropzone
						          	accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.mp3,.zip,.stl"
						          	onChangeStatus={this.handleChangeStatus}
									PreviewComponent={(props) => (
																			<FileUploadPreview
																			{...props}
																			customStatus={this.state.statusMap[props.meta.id]}
																			/>)}
								    getUploadParams={this.getUploadParams}
								    styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
								   />
						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.handleClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

      		
      						<Dialog open={this.state.audioOpen} aria-labelledby="audio-dialog-title" maxWidth="xs" PaperComponent={this.PaperComponent}>
 
						        <DialogTitle id="audio-dialog-title" style={{ cursor: 'move' }}>Voice Recorder</DialogTitle>
						        <DialogContent>
									
						        <Recorder
												record={true}
												audioURL={this.state.audioDetails.url}
												showUIAudio
												handleAudioStop={data => this.handleAudioStop(data)}
												handleOnChange={(value) => this.handleOnChange(value, 'firstname')}
												handleAudioUpload={data => this.handleAudioUpload(data)}
												handleReset={() => this.handleRest()} />
												
						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.audioClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

							  <Draggable>

							  <Dialog open={this.state.videoRecord} aria-labelledby="vrecord-dialog-title" maxWidth="sm">
 
						        <DialogTitle id="vrecord-dialog-title" style={{ cursor: 'move' }}>Screen Recorder</DialogTitle>
						        <DialogContent>
						        <ReactMediaRecorder
											      screen audio mediaRecorderOptions={{mimeType: "video/mp4;codecs=AVC"}}
											      render={({ status, startRecording, stopRecording, mediaBlobUrl }) => (
											        <div>
											          
											          {status==="idle" &&
											          <Tooltip title="Record Screen"><MusicVideoIcon style={{ color: '#5867dd',fontSize: 35}} onClick={startRecording}/></Tooltip>
											        	}
											          {status==="recording" &&
													  <>
											          <Tooltip title="Stop Recording"><StopIcon style={{ color: '#5867dd',fontSize: 35}} onClick={stopRecording}/></Tooltip> &nbsp; Recording...</>
											        	}
											        	{status === "stopped" &&
											          <Tooltip title="Preview Recording"><Button onClick={()=>this.setState({videoOpen:true,mediaBlobUrl:mediaBlobUrl})}>Preview</Button></Tooltip>
											          }
											          {status === "stopped" && 
											          <Tooltip title="Upload Recording"><Button onClick={()=>this.uploadVideo(mediaBlobUrl)}>Upload</Button></Tooltip>
											          }
											        </div>
											      )}
											    />
						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.vRecordClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>
							  </Draggable>


      						<Dialog open={this.state.videoOpen} aria-labelledby="video-dialog-title" maxWidth="sm">
 
						        <DialogTitle id="video-dialog-title" style={{ cursor: 'move' }}>Video Viewer</DialogTitle>
						        <DialogContent>
						        		<video src={this.state.mediaBlobUrl} style={{width:'100%',height:'auto'}} controls />
						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.videoClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

							  <Dialog open={this.state.shareOpen} aria-labelledby="share-dialog-title" maxWidth="xs" fullWidth={true}>
 
						        <DialogTitle id="share-dialog-title">Share
								{this.state.shareStatus && ' - File shared Successfully!'}
								</DialogTitle>
						        <DialogContent>
									<div className="col-lg-12">
											<Autocomplete
												id="tags-standard"
												options={this.state.users}
												onChange={this.onSelectTag}
											    sx={{ width: '100%' }}
												getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
												renderInput={(params) => (
														<TextField
														{...params}
															margin="normal"
															label="Select User"
												/>
											)}
											/>
                    
                   
									</div>
						        </DialogContent>
      

						        <DialogActions>
								<Button onClick={this.share} color="primary">
						            Share
						          </Button>
						          <Button onClick={this.shareClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>
      						

      						<Dialog open={this.state.imageOpen}  aria-labelledby="form-dialog-title" >
 
						        <DialogTitle id="form-dialog-title">Document/Image Viewer
						        			{this.state.status && ' - Annotation saved successfully!!'}
						        </DialogTitle>
						        <DialogContent>
						          {this.state.fileType!=null && this.state.fileType.includes("image") &&
						          <>
						          {/* <TextField  style={{'width':'100%'}} name="annotationType"
                                        id="annotationType" onChange={(e)=> this.setState({type:e.target.value})} label="Choose Shape"  select>
                                        <MenuItem key="RECTANGLE" value="RECTANGLE">Rectangle</MenuItem>
                                        <MenuItem key="OVAL" value="OVAL">Oval</MenuItem>
                                        
                                    </TextField>*/}
                              <Annotation
                              src={this.state.imageUrl}
                              alt='Two pebbles anthropomorphized holding hands'

                              annotations={this.state.annotations}

                              type={this.state.type}
                              value={this.state.annotation}
                              onChange={this.onChange}
                              onSubmit={this.onSubmit}
                            />
                            {this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag===null && x.parentFileId===this.state.id).length>0 &&
												<div className="kt-section">
													<h3>Practice</h3>
													<div className="kt-section__content">
														
														<div className="row">
														
														{this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag===null && x.parentFileId===this.state.id).map((file)=>{
															if(file.fileType.includes("audio")) 
															{ return (
																<div className="col-lg-12">
															<div className="row">
																
																<div className="col-lg-6">
																	<Tooltip title={file.fileName}>
																		<a href="#" onClick={()=>this.audioView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																				<img src="media/icons/svg/Files/Music.svg"/>
																			{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																			<br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																		</a>
																	</Tooltip>
																</div>
																<div className="col-lg-2">
																	<Tooltip title="Share">
																		<Share style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.setState({fileKey:file.originalFileKey,shareOpen:true})}/>
																	</Tooltip>
																</div>
																<div className="col-lg-6">
																	{this.state.audioUrl!=null && this.state.audioKey !==null && this.state.audioKey===file.fileKey &&
																		<ReactAudioPlayer
																		src={this.state.audioUrl}
																		autoPlay
																		controls
																		/>

																	}
																</div>
																
															</div>
															</div>
															)}
															else if (file.fileType.includes("video"))
															{return (
																<div className="col-lg-12">
															<div className="row">
																<div className="col-lg-6">
																	<Tooltip title={file.fileName}>
																		<a href="#" onClick={()=>this.videoView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																				<img src="media/icons/svg/Files/Media.svg"/>
																			{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																			<br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																		</a>
																	</Tooltip>
																</div>
																<div className="col-lg-2">
																	<Tooltip title="Share">
																		<Share style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.setState({fileKey:file.originalFileKey,shareOpen:true})}/>
																	</Tooltip>
																</div>
																
																
															</div>
															</div>
															)}
														})}
														</div>
														
													</div>
												</div>
												}
												 {this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag==='Referral' && x.parentFileId===this.state.id).length>0 &&
												<div className="kt-section">
													<h3>Referral</h3>
													<div className="kt-section__content">
														
														<div className="row">
														
														{this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag==='Referral' && x.parentFileId===this.state.id).map((file)=>{
															if(file.fileType.includes("audio")) 
															{ return (
																<div className="col-lg-12">
																<div className="row">
																	
																	<div className="col-lg-6">
																		<Tooltip title={file.fileName}>
																			<a href="#" onClick={()=>this.audioView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																					<img src="media/icons/svg/Files/Music.svg"/>
																				{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																				<br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																			</a>
																		</Tooltip>
																	</div>

																	<div className="col-lg-2">
																		<Tooltip title="Share">
																			<Share style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.setState({fileKey:file.originalFileKey,shareOpen:true})}/>
																		</Tooltip>
																	</div>

																	<div className="col-lg-6">
																		{this.state.audioUrl!=null && this.state.audioKey !==null && this.state.audioKey===file.fileKey &&
																			<ReactAudioPlayer
																			src={this.state.audioUrl}
																			autoPlay
																			controls
																			/>

																		}
																	</div>
																	
																</div>
																</div>
															)}
															else if (file.fileType.includes("video"))
															{return (
																<div className="col-lg-12">
																	<div className="row">
																		
																		<div className="col-lg-6">
																			<Tooltip title={file.fileName}>
																				<a href="#" onClick={()=>this.videoView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																						<img src="media/icons/svg/Files/Media.svg"/>
																					{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																					<br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																				</a>
																			</Tooltip>
																		</div>
																		<div className="col-lg-2">
																			<Tooltip title="Share">
																				<Share style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.setState({fileKey:file.originalFileKey,shareOpen:true})}/>
																			</Tooltip>
																		</div>
																		
																	</div>
															</div>
															)}
															})}
														</div>
														
													</div>
												</div>
												}
                            </>
                            }
                            {this.state.fileType!=null && !this.state.fileType.includes("image") && !this.state.fileType.includes("audio") &&
                            	<span style={{'text-align':'center'}}>
								<img src="media/icons/svg/Files/File.svg"/>
								</span>
																
                            }
                            {this.state.fileType!=null && this.state.fileType.includes("audio") &&
	                           	<ReactAudioPlayer
								  src={this.state.imageUrl}
								  autoPlay
								  controls
								/>

                            }
						        </DialogContent>
      

						        <DialogActions>
								{this.state.fileType!=null && this.state.fileType.includes("image") && this.state.mediaapisupport===true && 
                      			<ReactMediaRecorder
											      screen audio
											      render={({ status, startRecording, stopRecording, mediaBlobUrl }) => (
											        <div>
											          
											          {status==="idle"  && 
											          <Tooltip title="Record Screen"><MusicVideoIcon style={{ color: '#5867dd',fontSize: 35}} onClick={startRecording}/></Tooltip>
											        	}													   
													   
											          {status==="recording" &&
													  
											          <Tooltip title="Stop Recording"><StopIcon style={{ color: '#5867dd',fontSize: 35}} onClick={stopRecording}/></Tooltip>
											        	}
											        	{status === "stopped111" &&
											          <Tooltip title="Preview Recording"><Button onClick={()=>this.setState({videoOpen:true,mediaBlobUrl:mediaBlobUrl})}>Preview</Button></Tooltip>
											          }
											          {status === "stopped" && this.state.videoDetails ===false && this.state.uploadComplete===false &&
											          <Tooltip title="Upload Recording"><Button onClick={()=>this.uploadVideo(mediaBlobUrl)}>
														  Save Recording</Button></Tooltip>
											          }
													  {status === "stopped" && this.state.videoDetails ===true && 
											          <CircularProgress/>
											          }
													  
											        </div>
											      )}
											    />
                      					}

								{
									this.state.mediaapisupport ===false &&
									<Tooltip title="Screen capture not supported"><VideocamOffRoundedIcon style={{ color: '#red',fontSize: 35}}/></Tooltip>
								}

						         {this.state.fileType!=null && this.state.fileType.includes("image") &&
						        <Button onClick={()=>this.setState({audioOpen:true})} color="primary">
						            Record
						          </Button>
						      	}
						        {this.state.fileType!=null && this.state.fileType.includes("image") &&
						        <Button onClick={this.rotate} color="primary">
						            Rotate
						          </Button>
						      }
						        <Button color="primary">
						            <a href={this.state.imageUrl} target="_blank">Download</a>
						          </Button>
						          <Button onClick={this.delete} color="primary">
						            Archive
						          </Button>
						          {this.state.fileType!=null && this.state.fileType.includes("image") &&
						        <Button onClick={this.saveAnnotation} color="primary">
						            Save
						          </Button>
						      }
						          <Button onClick={this.imageClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

							{/**requirement drawer */}
									{this.state.selectedDrawerItem!=null  && this.state.patients!==null && 
									<Drawer anchor={'right'} open={this.state.drawerViewOpen} onClose={this.toggleViewDrawer}>
										<ProductRequirement onClose={()=>this.setState({drawerViewOpen:false})} productRequirement={this.state.selectedDrawerItem} patient={this.state.patients.length>0?this.state.patients[0]:this.state.patients} />
									</Drawer>
									}

									{this.state.viewtemTemplate!==null && this.state.viewtemTemplate!==undefined &&
											  <Dialog open={this.state.viewTemplateOpen}  aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth={true}>
							 
												<DialogTitle id="form-dialog-title"></DialogTitle>
												<DialogContent>
												  
												  <ViewTemplateData data={{template:this.state.viewtemTemplate,patient:this.state.viewtemPatient,fromPath:'/createpatient'}} />
							
												</DialogContent>
								  
							
												<DialogActions style={{justifyContent: 'flex-start'}}>
												  <Button onClick={this.viewTemplateClose} color="primary">
													Close
												  </Button>
												  
												</DialogActions>
								  
											  </Dialog>
											  }


 {this.state.addtemTemplate!==null && this.state.addtemTemplate!==undefined &&
                  <Dialog open={this.state.addTemplateOpen}  aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth={true}>
 
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent>
                      
                      <AddTemplateData data={{template:this.state.addtemTemplate,patient:this.state.addtemPatient,fromPath:'/createpatient'}} />

                    </DialogContent>
      

                    <DialogActions style={{justifyContent: 'flex-start'}}>
                      <Button onClick={this.addTemplateClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>
                  }

									
    	</>
    	);
	}   
}